import NL_EXT_1 from "./NL_EXT_1";
export default {
  NL_EXT_1,
};
